export class DocumentModel {
    fileSize: string;
    id: number;
    title: string;
    createdBy: string;
    description: string;
    filename: string;
    categoriesTitle: string;
    categories: string;
    downloads: number;
    uploadDate: string;
    filedata: string;
}
